import { createSelector } from 'reselect';

export const selectAnimals = ({ animals }) => animals.animals;
export const selectAnimalKeeping = ({ animals }) => animals.animalKeeping;

/** Merges the cattle subcategories 'oksekalv' and 'kvigekalv' into 'kalv'. (Only relevant for slaughter) */
export const selectCattleForSlaughter = createSelector(
  selectAnimals,
  (state) => ({
    ...state,
    animals: {
      ...state?.animals,
      cattle: state?.animals?.cattle?.map?.((c) => (c?.subcategory_name?.includes?.('kalv')
        ? ({
          ...c,
          subcategory_name: 'kalv',
        })
        : c)) || [],
    },
  }),
);
